import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-quick-chat",
  "use": "foquz-icon-vue-quick-chat-usage",
  "viewBox": "0 0 16 15.971",
  "content": "<symbol preserveAspectRatio=\"none\" overflow=\"visible\" viewBox=\"0 0 16 15.971\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-quick-chat\"><path d=\"M13.25 1H2.75C1.785 1 1 1.8 1 2.782v7.436C1 11.2 1.785 12 2.75 12H6v2.97L10.335 12h2.916c.965 0 1.75-.8 1.75-1.782V2.782C15 1.8 14.215 1 13.25 1z\" stroke=\"var(--stroke-0, white)\" stroke-width=\"2\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol